import axios from "axios";
import { User } from "../types/User";
import Cookies from "js-cookie";
import { ConfirmRequest } from "../types/ConfirmRequest";
import authAxios, { authHeader } from "./data";

const sendVerificationCode = async (type: string, values: any) => {
  return await axios.post(`/api/${type}/SendVerificationCode`, values);
};

const confirmVerificationCode = async (
  type: string,
  values: ConfirmRequest
) => {
  return await axios.post(`/api/${type}/ConfirmVerificationCode`, values);
};

const loginFirstStep = async (values: any) => {
  const response = await axios.post("/api/Auth/LoginFirstStep", values);

  return response.data;
};

const loginSecondStep = async (user: User) => {
  const response = await axios.post("/api/Auth/LoginSecondStep", user);

  return response.data;
};

const logout = async () => {
  const config: any = {
    headers: authHeader(),
  };

  return await authAxios.post("/api/Auth/Logout", {}, config);
};

const acceptAgreements = async () => {
  const config: any = {
    headers: authHeader(),
  };

  const response = await authAxios.post("/api/UserAgreements", {}, config);

  return response.data;
};

const refresh = async () => {
  const config: any = {
    headers: authHeader(),
  };

  const response = await axios.post("/api/Auth/Refresh", {}, config);

  return response.data;
};

const isLoggedIn = () => {
  return !!localStorage.getItem("userData");
};

const getRememberMeCode = (): string | null => {
  let rememberDeviceCode: string | undefined | null =
    Cookies.get("rememberMeCode");

  if (rememberDeviceCode === "null" || !rememberDeviceCode) {
    rememberDeviceCode = null;
  }

  return rememberDeviceCode;
};

const requestPasswordChange = async (values: any) => {
  const response = await axios.post(
    "/api/ForgotPassword/RequestPasswordChange",
    values
  );

  return response.data;
};

const changePassword = async (values: any) => {
  const response = await axios.post(
    "/api/ForgotPassword/ChangePassword",
    values
  );

  return response.data;
};

const show = async (values: any) => {
  const response = await axios.post("/api/ForgotUsername/Show", values);

  return response.data;
};

const AuthService = {
  loginSecondStep,
  isLoggedIn,
  sendVerificationCode,
  confirmVerificationCode,
  loginFirstStep,
  logout,
  refresh,
  getRememberMeCode,
  requestPasswordChange,
  changePassword,
  show,
  acceptAgreements,
};

export default AuthService;
